const initialState = {
  stratClassData: [],
};

const stratClassSlice = (set) => ({
  ...initialState,
  setStratClassData: (stratClassData) => set({ stratClassData }),
  resetStratClassData: () => set(initialState),
});

export default stratClassSlice;
